import React from 'react';
import './LocationName.less';

export const LocationName = ({text}) => {
	return <span className="location-name">{text}</span>
}
